var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatarT = function SvgDefaultAvatarT(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 55.3c4.5 0 6.7-.4 6.7-1.6 0-.9-.9-1.2-3.4-1.3-.6-.2-.8-2.1-.8-4.5V33.7c0-3.1.1-5.5.8-5.7h.9c2.6 0 4.9.3 5.3 1 .5.7.7 1.4 1 2.4.6 2.4 1.1 3.3 2 3.3.8 0 1.3-1 1.3-2.6 0-3.3-1.6-7.6-3.3-7.6-1.2 0-1 .7-2.7.7H32.2c-1.8 0-1.6-.7-2.7-.7-1.7 0-3.3 4.4-3.3 7.6 0 1.6.5 2.6 1.3 2.6s1.3-.9 2-3.3c.3-1 .5-1.8 1-2.4.4-.8 2.7-1 5.3-1h.9c.7.2.8 2.6.8 5.7v14.1c0 2.4-.2 4.3-.8 4.5-2.5.1-3.4.4-3.4 1.3 0 1.2 2.3 1.7 6.7 1.7z"
  })));
};
export default SvgDefaultAvatarT;